var map = {
	"./what-is-sms-service-de.html": 1977,
	"./what-is-sms-service-en.html": 1978,
	"./what-is-sms-service-es.html": 1979,
	"./what-is-sms-service-fr.html": 1980,
	"./what-is-sms-service-ja.html": 1981,
	"./what-is-sms-service-pt.html": 1982,
	"./what-is-sms-service-zh.html": 1983
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1976;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/what-is-sms-service ^\.\/what\-is\-sms\-service\-.*\.html$
// module id = 1976
// module chunks = 0